import { HandoffRuleEditorValue } from './contracts';

export const isRemovedAgentId = (
  agentId: string | undefined,
  squadAgentIds: ReadonlySet<string>,
): agentId is string => Boolean(agentId) && !squadAgentIds.has(agentId as string);

export const hasRemovedRouteAgent = (
  rule: Pick<HandoffRuleEditorValue, 'fromAgentId' | 'toAgentId'>,
  squadAgentIds: ReadonlySet<string>,
): boolean =>
  isRemovedAgentId(rule.fromAgentId, squadAgentIds) ||
  isRemovedAgentId(rule.toAgentId, squadAgentIds);
